// src/components/ErrorBoundary.jsx
import { Button } from "@mui/material";
import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: "User Not Logged In" };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="App">
          <div style={{background: '#ffffff', height: '100dvh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <p>{this.state.errorMessage}</p>
            <Button
              className="btn-outlined"
              onClick={() => {
                this.setState({ hasError: false });
                window.location.href = "/";
              }}
            >
              Go to Login
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}